/**
 * Mixin with computed properties for log properties
 * Bridges disparity between TP and local property names
 */
import imagetypes from "@/common/imagetypes";
import _isObject from "lodash/isObject";
import {mapGetters} from "vuex";

export default {
	computed: {
		...mapGetters(['logSearchParams']),
		object() {
			return this.log || this.pallet || this.objectToAdd;
		},
		isTableTop() {
			return this.object.strSpecieName === "TableTop" || this.object.specieGid === 'VSTT1' || (this.object.species && this.object.species.speciesId === 'VSTT1');
		},
		logId() {
			return this.object ? (this.object.intLogId || this.object.logId) : null;
		},
		logNo() {
			return this.object.strLogNo || this.object.logNo;
		},
		speciesName() {
			if (this.object.strSpecieName === "TableTop" || this.object.specieGid === 'VSTT1' || (this.object.species && this.object.species.speciesId === 'VSTT1')) {
				return this.object.strCustomerQualityName || this.object.customerQualityName;
			}
			if (this.$route.name !== 'search' && !this.watchlistItem && this.watchlist && this.watchlist.species) {
				return this.watchlist.species.name;
			}
			if (!this.watchlistItem && this.logSearchParams.species && _isObject(this.logSearchParams.species)) {
				return this.logSearchParams.species.name;
			}
			if (this.object.species) {
				return this.object.species.translatedName ? this.object.species.translatedName : this.object.species.name
			}
			return this.object.strSpecieName;
		},
		teaser() {
			if (this.watchlistItem && this.watchlistItem.teaser) {
				return this.watchlistItem.localTeaser ? '/' + this.watchlistItem.localTeaser : this.watchlistItem.teaser;
			}

			return this.object.localTeaser ? '/' + this.object.localTeaser : this.object.strPreviewImageURL || this.object.teaser;
		},
		backupTeaser() {
			return this.watchlistItem && this.watchlistItem.localBackupTeaser ? this.watchlistItem.localBackupTeaser : this.object.localBackupTeaser;
		},
		logArea() {
			if (this.virtual && this.object.bundles) {
				return this.object.bundles.reduce((carry, bundle) => {
					return carry + bundle.decArea;
				}, 0.0);
			}

			return this.object.decLogArea || this.object.logArea;
		},
		resultAreaNotRemeasured() {
			return this.object.decResultAreaNotRemeasured;
		},
		resultAreaMeasuredBack() {
			return this.object.decResultAreaMeasuredBack;
		},
		thicknessMm() {
			return this.object.decThicknessMm || this.object.thicknessMm;
		},
		maxLength() {
			if (this.virtual && this.object.bundles) {
				return this.object.bundles.reduce((carry, bundle) => {
					return carry > bundle.intLength ? carry : bundle.intLength;
				}, 0);
			}

			return this.object.intMaxLength || this.object.intMaxPalletLength || this.object.maxLength;
		},
		customerQualityName() {
			if (this.object.strSpecieName === "TableTop" || this.object.specieGid === 'VSTT1' || (this.object.species && this.object.species.speciesId === 'VSTT1')) {
				return null;
			}
			return this.object.strCustomerQualityName || this.object.customerQualityName;
		},
		structure() {
			return this.object.strStructure || this.object.structure;
		},
		characteristic() {
			return this.object.strCharacteristic || this.object.characteristic;
		},
		grade() {
			return this.object.decGrade || this.object.grade;
		},
		place() {
			return this.object.strPlace || this.object.place;
		},
		internalQualityName() {
			return this.object.strInternalQualityName || this.object.internalQualityName;
		},
		logInfo() {
			return this.object.strLogInfo || this.object.logInfo;
		},
		allImageUrls() {
			return this.object.lstImageURLs || (this.object.imageUrls ? JSON.parse(this.object.imageUrls) : []);
		},
		// image urls without excluded images
		imageUrls() {
			let images = this.allImageUrls;

			if (this.watchlistItem && this.watchlistItem.excludedImages) {
				// filter excluded images if this is a watchlist item detail view
				const excludedImages = _isObject(this.watchlistItem.excludedImages) ? this.watchlistItem.excludedImages : JSON.parse(this.watchlistItem.excludedImages);
				return images ? images.filter(image => !excludedImages.includes(image.strImageURL)) : [];
			}

			return images;
		},
		backColor() {
			return this.object.backColor || this.object.strBackColor;
		},
		allSmallImages() {
			return this.allImageUrls ?
				this.allImageUrls.filter(image => image.intType === imagetypes.SMALL_MANUAL).map(image => image.strImageURL) :
				[];
		},
		// small image urls without excluded images
		smallImages() {
			return this.imageUrls ?
				this.imageUrls.filter(image => image.intType === imagetypes.SMALL_MANUAL).map(image => image.strImageURL) :
				[];
		},
		unavailable() {
			return this.object.unavailable || false;
		},

		palletNo() {
			return this.object.strPalletNo || this.object.palletNo;
		},
		palletId() {
			return this.object.intPalletId || this.object.palletId;
		},
		palletArea() {
			return this.object.decPalletArea || this.object.palletArea;
		},
		palletResultArea() {
			return this.object.decResultArea;
		},
		palletType() {
			return this.object.intPalletType || this.object.palletType;
		},
		palletInfo() {
			return this.object.strPalletInfo || this.object.palletInfo;
		},
		palletInfoInternal() {
			return this.object.strPalletInfoIntern || this.object.palletInfoIntern;
		},
		bundleCount() {
			return this.object.intResultBundleCount;
		}
	}
}